import { Directive } from 'vue'
//
const focus: Directive = (el: HTMLElement, binding) => {
  if (binding.value) {
    el.focus()
  }
}
export default {
  name: 'focus',
  definition: focus,
}
